export default __webpack_public_path__ + "static/media/thimble.484e9435.svg";